<template>
  <div class="blog-post blog organazation">
    <header>
      <topbar />
      <navbar v-show="isMobile !== true" />
      <mobile-nav v-show="isMobile" />
      <section-header text="Colleges of University" />
    </header>
    <main>
      <b-container class="mt-5">
        <b-row>
          <b-col sm="12" md="12" class="p-0">
            <b-row
              class="px-md-5 align-items-stretch"
              v-if="colleges.length !== 0"
            >
              <b-col
                sm="12"
                md="4"
                class="mb-5"
                v-for="(college, index) in colleges"
                :key="college.id"
              >
                <div
                  class="blog-card"
                  data-aos="fade"
                  :data-aos-delay="`${index + 5}00`"
                >
                  <div class="image-placeholder">
                    <img :src="getImage(college.logo)" alt="" />
                  </div>
                  <div class="content">
                    <h3>
                      <router-link
                        :to="{
                          name: 'departments',
                          params: { id: college.id },
                        }"
                        >{{ shortenTitle(college.name) }}
                      </router-link>
                    </h3>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </main>
    <footer>
      <footer-component />
    </footer>
  </div>
</template>

<script>
import { filesUrl } from "@/main";
import MobileNav from "@/components/layout/MobileNav.component.vue";
import Topbar from "@/components/layout/Topbar.component.vue";
import Navbar from "@/components/layout/Navbar.component.vue";
import FooterComponent from "@/components/layout/FooterComponent.component.vue";
import SectionHeader from "@/components/layout/SectionHeader.component.vue";
// import BlogSidebar from "@/components/blog/BlogSidebar.component.vue";
export default {
  components: {
    Topbar,
    Navbar,
    SectionHeader,
    // BlogSidebar,
    FooterComponent,
    MobileNav,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      colleges: [],
      popularPosts: [],
      isMobile: false,
      lang: null,
      totalCount: "",
    };
  },
  watch: {
    currentPage: {
      handler: function () {
        this.getAllPosts();
      },
    },
  },
  computed: {
    rows() {
      return this.posts.length;
    },
  },
  async mounted() {

    if (window.innerWidth > 991) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
    this.getColleges();
  },
  methods: {
    getColleges() {
      let skip = this.currentPage - 1;
      this.axios
        .get(`colledges?skip=${skip}&take=${this.perPage}`)
        .then((res) => {
          this.colleges = res.data.items;
        });
    },
    getImage(path) {
      return `${filesUrl}/${path}`;
    },
    shortenTitle(text) {
      if (text !== null) {
        if (text.length > 50) {
          let maxLength = 50;
          let trimmedString = text.substr(0, maxLength);
          return trimmedString + " ...";
        } else {
          return text;
        }
      } else {
        return "";
      }
    },
  },
};
</script>
